import { combineReducers } from "redux";
import { Authentication, AuthenticationState } from "./redux/auth/reducer";
import { Overview, OverviewState } from "./redux/changeLog/reducer";
import { Partners, PartnersState } from "./redux/partners/reducer";
import { SubCompanies } from "views/admin/partnerDetail/services/subCompanies/reducer";
import { SubCompaniesState } from "views/admin/partnerDetail/services/subCompanies/types";

const allReducers = combineReducers({
  overview: Overview,
  partners: Partners,
  authentication: Authentication,
  subCompanies: SubCompanies,
});

const rootReducer = (state: any, action: any) => {
  return allReducers(state, action);
};

export default rootReducer;

export interface RootReducer {
  overview: OverviewState;
  authentication: AuthenticationState;
  partners: PartnersState;
  subCompanies: SubCompaniesState;
}
